import { SelectChangeEvent, SelectProps } from '@mui/material'
import { useCallback } from 'react'
import { Controller, ControllerRenderProps, FieldValues, useFormContext } from 'react-hook-form'
import { Select as MuiSelect } from '../../inputs'
import { ErrorMessage } from '../ErrorMessage'

interface Option {
  group?: string
  name: string
  onChange?: (event: SelectChangeEvent<unknown>, child: React.ReactNode) => void
  value: any
}

type Props = SelectProps & {
  defaultValue?: string
  label: string
  name: string
  options: Option[]
}

type Field = ControllerRenderProps<FieldValues, string>

const Select = ({ defaultValue, name, onChange: onChangeProp, onFocus, ...rest }: Props) => {
  const {
    control,
    formState: { errors },
    clearErrors,
  } = useFormContext()

  const error = errors?.[name]
  const hasError = Boolean(error)

  const render = ({ field }: { field: Field }) => {
    const { onChange: onChangeFormHandler } = field

    const onChangeProxy = useCallback(
      (event: SelectChangeEvent<unknown>, child: React.ReactNode) => {
        if (onChangeProp) {
          onChangeProp(event, child)
        }
        clearErrors()
        onChangeFormHandler(event, child)
      },
      [onChangeFormHandler, onChangeProp]
    )

    return (
      <>
        <MuiSelect {...rest} {...field} error={hasError} onChange={onChangeProxy} onFocus={onFocus} />
        {hasError && <ErrorMessage message={error.message} />}
      </>
    )
  }

  return <Controller control={control} defaultValue={defaultValue} name={name} render={render} />
}

export { Select }
